export const LIST_PLAN_EDITORS_SUCCESS = 'LIST_PLAN_EDITORS_SUCCESS';
export const LIST_PLAN_EDITORS_FAILURE = 'LIST_PLAN_EDITORS_FAILURE';

export const NEW_PLAN_EDITOR_SUCCESS = 'NEW_PLAN_EDITOR_SUCCESS';
export const NEW_PLAN_EDITOR_FAILURE = 'NEW_PLAN_EDITOR_FAILURE';

export const CREATE_PLAN_EDITOR_SUCCESS = 'CREATE_PLAN_EDITOR_SUCCESS';
export const CREATE_PLAN_EDITOR_FAILURE = 'CREATE_PLAN_EDITOR_FAILURE';

export const EDIT_PLAN_EDITOR_SUCCESS = 'EDIT_PLAN_EDITOR_SUCCESS';
export const EDIT_PLAN_EDITOR_FAILURE = 'EDIT_PLAN_EDITOR_FAILURE';

export const UPDATE_PLAN_EDITOR_SUCCESS = 'UPDATE_PLAN_EDITOR_SUCCESS';
export const UPDATE_PLAN_EDITOR_FAILURE = 'UPDATE_PLAN_EDITOR_FAILURE';

export const DELETE_PLAN_EDITOR_SUCCESS = 'DELETE_PLAN_EDITOR_SUCCESS';
export const DELETE_PLAN_EDITOR_FAILURE = 'DELETE_PLAN_EDITOR_FAILURE';
